class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      console.log('PredictiveSearch initialized'); // Debug
      this.input = this.querySelector('input[data-predictive-search]');
      this.predictiveSearchResults = this.querySelector('.predictive-search');
      this.loadingState = this.querySelector('.predictive-search__loading-state');
      this.resultsContainer = this.querySelector('.predictive-search__results');
      
      if (!this.input || !this.predictiveSearchResults || !this.loadingState || !this.resultsContainer) {
        console.error('Required elements not found:', { // Debug
          input: !!this.input,
          results: !!this.predictiveSearchResults,
          loading: !!this.loadingState,
          container: !!this.resultsContainer
        });
        return;
      }
      
      this.setupEventListeners();
    }
  
    setupEventListeners() {
      const debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);
  
      this.input.addEventListener('input', debouncedOnChange.bind(this));
      this.input.addEventListener('focus', this.onFocus.bind(this));
      console.log('Event listeners set up'); // Debug
    }
  
    async onChange() {
      const searchTerm = this.input.value.trim();
      console.log('Search term:', searchTerm); // Debug
  
      if (!searchTerm.length) {
        this.close();
        return;
      }
  
      this.predictiveSearchResults.hidden = false;
      this.loadingState.hidden = false;
      this.resultsContainer.hidden = true;
  
      try {
        const searchUrl = `/search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product,collection&resources[limit]=4&resources[options][unavailable_products]=last`;
        console.log('Fetching from:', searchUrl); // Debug
        
        const response = await fetch(searchUrl);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        
        console.log('Search results:', data); // Debug
        
        this.loadingState.hidden = true;
        this.resultsContainer.hidden = false;
        
        this.renderSearchResults(data);
      } catch (error) {
        console.error('Search error:', error); // Debug
        this.close();
        this.resultsContainer.innerHTML = '<p class="predictive-search-no-results">An error occurred while searching</p>';
        this.resultsContainer.hidden = false;
      }
    }
  
    onFocus() {
      console.log('Input focused, value length:', this.input.value.length); // Debug
      if (this.input.value.length) {
        this.predictiveSearchResults.hidden = false;
      }
    }
  
    close() {
      this.predictiveSearchResults.hidden = true;
      this.loadingState.hidden = true;
      this.resultsContainer.hidden = true;
    }
  
    renderSearchResults(data) {
      const products = data.resources.results.products || [];
      const collections = data.resources.results.collections || [];
      
      console.log('Rendering results:', { // Debug
        productsCount: products.length,
        collectionsCount: collections.length
      });
  
      const resultsHTML = `
        ${collections.length ? `
          <div class="predictive-search-section">
            <h3 class="text-sm mb-1">Collections</h3>
            <ul>
              ${collections.map(collection => `
                <li>
                  <a href="${collection.url}" class="predictive-search-item">
                    ${collection.title}
                  </a>
                </li>
              `).join('')}
            </ul>
          </div>
        ` : ''}
        
        ${products.length ? `
          <div class="predictive-search-section">
            <h3 class="text-sm mb-1">Products</h3>
            <ul>
              ${products.map(product => `
                <li>
                  <a href="${product.url}" class="predictive-search-item">
                    ${product.title}
                  </a>
                </li>
              `).join('')}
            </ul>
          </div>
        ` : ''}
        
        ${!products.length && !collections.length ? `
          <p class="predictive-search-no-results">No results found</p>
        ` : ''}
      `;
  
      this.resultsContainer.innerHTML = resultsHTML;
    }
  }
  
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  
  // Initialize search functionality
  const searchModal = document.getElementById('searchModal');
  const searchInput = searchModal.querySelector('input[type="search"]');
  const closeButton = searchModal.querySelector('.search-close');
  const searchButton = document.querySelector('.header__icon--search');
  
  // Custom element for predictive search
  customElements.define('predictive-search', PredictiveSearch);
  
  // Handle opening search from header button
  searchButton.addEventListener('click', () => {
    searchModal.showModal();
    searchInput.focus();
  });
  
  // Close handlers
  closeButton.addEventListener('click', () => searchModal.close());
  
  searchModal.addEventListener('click', (e) => {
    if (e.target === searchModal) {
      searchModal.close();
    }
  });
  
  // Close on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchModal.open) {
      searchModal.close();
    }
  });
  
  // Update aria-expanded state
  searchButton.addEventListener('click', () => {
    searchButton.setAttribute('aria-expanded', 'true');
  });
  
  searchModal.addEventListener('close', () => {
    searchButton.setAttribute('aria-expanded', 'false');
  });